import React, { PropsWithChildren } from 'react';
import { TooltipWrapper } from '../../tooltip';
import { TooltipPadding, WidgetContainer, WidgetHeader } from './styles';

export interface WidgetWrapperProps {
  title: string;
  description: React.JSX.Element;
}

export const WidgetWrapper: React.FC<PropsWithChildren<WidgetWrapperProps>> = ({
  title,
  description,
  children
}) => {
  return (
    <WidgetContainer className="widget-container">
      <WidgetHeader variant="h3">{title}</WidgetHeader>
      <TooltipPadding>
        <TooltipWrapper title="What does this calculator do?" description={description} />
      </TooltipPadding>
      {children}
    </WidgetContainer>
  );
};
